
export const SEARCH_GAMEHUB    =     "SEARCH_GAMEHUB";
export const CATALOGS_GAMEHUB    =     "CATALOGS_GAMEHUB";
export const GET_GAMEHUB_BY_HOT_STATUS    =     "GET_GAMEHUB_BY_HOT_STATUS";
export const GET_GAMEHUB_BY_POPULAR_STATUS    =     "GET_GAMEHUB_BY_POPULAR_STATUS";
export const GET_GAMEHUB_BY_RECOMMEND_STATUS    =     "GET_GAMEHUB_BY_RECOMMEND_STATUS";
export const GET_GAMEHUB_BY_HOT_PRICES    =     "GET_GAMEHUB_BY_HOT_PRICES";
